import { AnalyticsBrowser } from "@segment/analytics-next";

export default defineNuxtPlugin((nuxtApp) => {
  const { public: publicConfig } = useRuntimeConfig();

  const analytics = AnalyticsBrowser.load(
    {
      writeKey: publicConfig.segmentWriteKey,
      cdnURL: "https://squidward.boostingmarket.com",
    },
    {
      integrations: {
        "Segment.io": {
          // POST https://MY-CUSTOM-API-PROXY.com/v1/t --> proxies to
          // https://api.segment.io/v1/t
          apiHost: "patrick.boostingmarket.com/v1",
          protocol: "https", // optional
        },
      },
    }
  );
  window.analytics = analytics;
});
